import { render } from "./UserActions.vue?vue&type=template&id=0e8dd356&scoped=true"
import script from "./UserActions.vue?vue&type=script&lang=js"
export * from "./UserActions.vue?vue&type=script&lang=js"

import "./UserActions.vue?vue&type=style&index=0&id=0e8dd356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8dd356"]])

export default __exports__